var React = require('react');

function StarHalfInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"m9 1.277 2.072 4.87 5.273.467-3.992 3.475 1.186 5.159L9 12.525l-4.54 2.723 1.187-5.159-3.992-3.475 5.273-.466L9 1.278Z","stroke":"currentColor","key":0}),React.createElement("path",{"fill":"currentColor","d":"M9 1.824v11.284l-4.304 1.644.727-4.288-3.576-3.803 5.087-.477z","key":1})]));
}

StarHalfInline.defaultProps = {"width":"18","height":"17"};

module.exports = StarHalfInline;

StarHalfInline.default = StarHalfInline;
